<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}用户信息
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 基本信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>基本信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  用户名
                </th>
                <td v-if="dataId || isSite">
                  <el-input type="text" autocomplete="off" v-model="formData.username" clearable disabled/>
                </td>
                <td v-else>
                  <el-input type="text" autocomplete="off" v-model="formData.username" clearable/>
                </td>
                <th>
                  <em class="f-red" v-if="formData.id == null">*</em>
                  {{ formData.id == null ? '密码' : '新密码' }}
                </th>
                <td>
                  <el-input type="password" autocomplete="off" v-model="formData.password" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  姓名
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.name" clearable/>
                </td>
                <th>
                  手机号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="phone" @blur="surePhone" clearable/>
                </td>
              </tr>
              <tr>

                <th>
                  <em class="f-red">*</em>
                  状态
                </th>
                <td>
                  <el-select v-model="formData.lockFlag">
                    <el-option label="有效" :value="0"/>
                    <el-option label="锁定" :value="1"/>
                  </el-select>
                </td>
                <th>
                  昵称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.nickname" clearable/>
                </td>
                <th>
                  邮箱
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.email" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否禁用
                </th>
                <td>
                  <el-select v-model="formData.delFlag">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr v-if="isSite">
                <th>
                  B号码处理状态
                </th>
                <td>
                  <el-select v-model="formData.telBUnband" style="width: 165px;" :disabled="true">
                    <el-option label="无须处理" :value="0" />
                    <el-option label="待解绑" :value="1" />
                    <el-option label="解绑成功" :value="2" />
                    <el-option label="待解绑后重绑" :value="4" />
                    <el-option label="解重绑成功" :value="5" />
                    <el-option label="处理失败" :value="9" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <th v-if="!isSite">
                  <em class="f-red">*</em>
                  岗位
                </th>
                <td v-if="!isSite" colspan="5">
                  <el-select v-model="postList" multiple placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in postOptions" :key="item.postName" :label="item.postName" :value="item.postId">
                    </el-option>
                  </el-select>
                </td>
                <th>
                  是否使用app
                </th>
                <td>
                  <el-select v-model="formData.userApp" style="width: 165px;" >
                    <el-option label="不启用" :value="0" />
                    <el-option label="启用" :value="1" />
                  </el-select>
                </td>
              </tr>
              <tr>

                <th>
                  <em class="f-red">*</em>
                  角色
                </th>
                <td colspan="7">
                  <el-select v-model="role" multiple placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in rolesOptions" :key="item.roleName" :label="item.roleName" :value="item.roleId
                        ">
                    </el-option>
                  </el-select>
                </td>
                <!-- 部门 -->

              </tr>

              <tr v-if="!isSite">
                <th>
                  <em class="f-red">*</em>
                  所属部门
                </th>
                <td colspan="7">
                  <avue-input-tree style="width: 100%;"
                                   check-strictly v-model="deptId" :node-click="getNodeData" :dic="treeDeptData"
                                   :props="defaultProps"
                                   multiple placeholder="请选择所属部门"/>
                </td>
              </tr>
              <tr v-if="!isSite">
                <th>是否为店铺用户</th>
                <td>
                  <el-select v-model="formData.isShopUser" @change="() => {formData.buyShopIdList = []}">
                    <el-option :value="0" label="否"/>
                    <el-option :value="1" label="是"/>
                  </el-select>
                </td>

                <th v-if="formData.isShopUser==1">关联店铺</th>
                <td v-if="formData.isShopUser==1" colspan="6">
                  <buy-shop-multiple-select :buy-shop-id-list.sync="formData.buyShopIdList"
                                            style="width: 100%;"/>
                </td>
              </tr>
              <tr v-if="!isSite">
                <th>是否为品牌用户</th>
                <td>
                  <el-select v-model="formData.isBrandUser" @change="() => {formData.brandIdList = []}">
                    <el-option :value="0" label="否"/>
                    <el-option :value="1" label="是"/>
                  </el-select>
                </td>

                <th v-if="formData.isBrandUser==1">关联品牌</th>
                <td v-if="formData.isBrandUser==1" colspan="6">
                  <brand-multiple-select :brand-id-list.sync="formData.brandIdList"
                                         style="width: 100%;"/>
                </td>
              </tr>
              <tr v-if="!isSite">
                <th>用户图片</th>
                <td >
                  <div class="form_picture">
                    <!-- <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove1"
                    list-type="picture-card" :file-list="picList1"
                    :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }" :limit="1"
                    :auto-upload="true" :headers="headers">
                    <i slot="default" class="el-icon-plus"></i>
                  </el-upload> -->
                    <photoUpload :photo-url.sync="formData.userPic" />

                  </div>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createDate }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import {editPageMixins, siteMixins} from '@/mixins/tabChang'
import Tinymce from '@/components/Tinymce';
import pager from '@/components/pager/index.vue';
import PhotoUpload from "@/components/formItem/photoUpload.vue"
import ItemCategorySelect from "@/components/formItem/itemCategorySelect.vue"
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import {addObj, delObj, fetchList, putObj, getObj} from "@/api/admin/user";
// 岗位
import {listPosts} from "@/api/admin/post";
// 角色
import {deptRoleList} from "@/api/admin/role";
import store from "@/store";
// 部门
import {fetchTree} from "@/api/admin/dept";
import BuyShopMultipleSelect from "@/components/formItem/buyShopMultipleSelect.vue";
import BrandMultipleSelect from "@/components/formItem/brandMultipleSelect.vue";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  mixins: [editPageMixins,siteMixins],
  components: {
    BrandMultipleSelect,
    BuyShopMultipleSelect,
    OrgSearch,
    ItemCategorySelect,
    PhotoUpload,
    Tinymce,
    pager
  },
  data() {
    return {
      defaultProps: {
        label: "name",
        value: "id"
      },
      phone: '',
      showItemPop: false,
      isSite: false,
      postList: [],
      role: [],
      // 角色
      treeDeptData: [],
      deptId: [],
      rolesOptions: [],
      postOptions: [],
      valueListSelected: [],
      value: '',
      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      formData: {
        userApp: 1,
        id: null,
        post: [],
        roleList: [],
        postList: [],
        lockFlag: 0,
        delFlag: 0,
        dataId: null,
        role: [],
        deptIds: [],
        isShopUser: 0,
        isBrandUser: 0,
        buyShopIdList: [],
        brandIdList: [],
        userPic:""
      },
      showProductCategoryDialog: false,
      selectedData: []
    };
  },
  watch: {
    // 联系方式验证
    phone: {
      handler(newVal, oldVal) {
        this.formData.phone = newVal
        var numReg = /^[0-9]+$/
        var numRe = new RegExp(numReg)
        if (!numRe.test(this.formData.phone)) {
          this.$message.error("请输入正确的11位手机号码");
        } else if (this.formData.phone.length > 12) {
          this.$message.error("手机号码不能超过12位");
          this.formData.phone = this.formData.phone.slice(0, 12);
          this.phone = this.formData.phone
        }
      },
      deep: true, // 加这个属性，深度监听
    },
  },
  computed: {
    getExcludeIdList() {
      let temp = []
      if (this.formData.id) {
        temp.push(this.formData.id)
      }
      if (this.formData.basItemPackageDTOList) {
        temp.push(...this.formData.basItemPackageDTOList.map(item => item.packageItemId))
      }
      return temp
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    const userInfo = store.getters.userInfo;
    console.log("userInfo====", userInfo)
    if (userInfo.snUserId) {
      this.isSite = true;
      this.formData.snUserId = userInfo.snUserId
    }
  },
  mounted() {
    // 岗位
    listPosts().then(response => {
      this.postOptions = response.data.data
      console.log(this.postOptions, "postOptions岗位值");
    });
    // 角色
    deptRoleList().then(response => {
      this.rolesOptions = response.data.data;
      // 移除1，2级服务商角色
      if (!this.isSite) {
        this.rolesOptions = this.rolesOptions.filter(item => (item.roleDesc !== '一级服务商角色' && item.roleDesc !== '二级服务商角色'))
      } else {
        if (this.currentSiteLevel === 1){ //1级服务商角色
          this.rolesOptions = this.rolesOptions.filter(item => (item.roleDesc === '一级服务商-信息员' || item.roleDesc === '一级服务商-配件员'
            || item.roleDesc === '一级服务商-技术员' || item.roleDesc === '一级服务商-结算员' || item.roleDesc === '一级服务商-全部权限'
          ))
        }else if(this.currentSiteLevel === 2){//2级服务商角色
          this.rolesOptions = this.rolesOptions.filter(item => (item.roleDesc === '二级服务商-信息员' || item.roleDesc === '二级服务商-配件员'
            || item.roleDesc === '二级服务商-技术员' || item.roleDesc === '二级服务商-结算员' || item.roleDesc === '二级服务商-全部权限'
          ))
        }
      }
    });
    // 部门
    fetchTree().then(response => {
      let temp = []
      this.treeDeptData = response.data.data;
      this.treeDeptData.forEach(item => ({
        label: item.name
      }))

      console.log(this.treeDeptData, 'this.treeDeptData树的数据');
    });

    this.getData();
    console.log(this._dataId, "_dataId的值");
  },
  methods: {

    surePhone(){
      if (this.formData.phone.length>0 && this.formData.phone.length!= 11&& this.formData.phone.length!= 12){
        this.$message.error("请输入正确的手机号",);
      }
      if (this.formData.phone.length==11) {
        if(this.formData.phone[0]!=1){
          this.$message.error("请输入正确的11位手机号码",);
        }
      }
      if((this.formData.phone.length==12)){
        if(this.formData.phone[0]!=0){
          this.$message.error("固定电话必须填写区号,以0开头");
        }
      }
    },

    getNodeData() {
      deptRoleList().then(response => {
        this.rolesOptions = response.data.data;
      });
      listPosts().then(response => {
        this.postOptions = response.data.data
      })
    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        // this.$http.get(getObj(this._dataId).then(response => {
        //   this.formData = response.data.data;
        // }))
        this.$http({
          url: '/admin/user/' + this._dataId,
          method: `get`,
          // data: this.dataId
        }).then((response) => {
          this.formData = response.data.data;
          this.phone = this.formData.phone;
          let temp = []
          this.formData.postList.forEach(item => {
            temp.push(item.postId)
          })
          this.postList = temp
          console.log(this.postList, this.formData);
          // 角色
          let temp2 = []
          this.formData.roleList.forEach(item => {
            temp2.push(item.roleId)
          })
          this.role = temp2
          console.log(this.role, '角色值');
          let temp3 = []
          this.formData.deptList.forEach(item => {
            temp3.push(item.deptId)
          })
          this.deptId = temp3
          // .postName
          console.log(this.formData, this.postList, "formData的值");


          this.formData.password = null

        }).catch(e => {
          // console.error(e)
          // this.$message.error("保存失败！");
        })
      }
    },

    saveData() {

      if(this.formData.phone!=null&&this.formData.phone!=''){
        if (this.formData.phone.length>0 && this.formData.phone.length!= 11&& this.formData.phone.length!= 12){
          if(this.formData.phone.length!= 11){
            this.$message.error("请输入正确的手机号");
            return;
          }
        }
        if (this.formData.phone.length==11) {
          if(this.formData.phone[0]!=1){
            this.$message.error("请输入正确的11位手机号码");
            return;
          }
        }
        if((this.formData.phone.length==12)){
          if(this.formData.phone[0]!=0){
            this.$message.error("固定电话必须填写区号,以0开头");
            return;
          }
        }
      }

      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.formData.phone = this.phone;
          let temp = []
          this.postList.forEach(item => {
            temp.push(
              item
            )
            this.formData.post = temp
            this.formData.postList = this.formData.post
          })

          let temp3 = []
          this.role.forEach(item => {
            temp3.push(
              item
            )
          })
          this.formData.role = temp3
          this.formData.roleList = this.formData.role

          // 部门
          let temp4 = []
          this.deptId.forEach(item => {
            temp4.push(
              item
            )
          })
          this.formData.deptIds = temp4
          // this.formData.roleList=this.formData.role

          // console.log(this.role,"this.role角色");
          // this.formData.userApp = 1
          if (!this.formData.name) {
            this.$message.error("姓名必填！");
            return
          }
          if (this.formData.roleList.length == 0) {
            this.$message.error("角色必选！");
            return
          }
          console.log(this.formData, this.postList, 'this.formData.postList的值');
          this.$baseConfirm('您确定要保存吗？').then(() => {
            if (this._dataId == 0) {
              this.$mask.open()
              this.$http({
                url: '/admin/user',
                method: `post`,
                data: this.formData
              }).then(() => {
                this.$message.success("保存成功！");
                this.reload()
                // this.$emit('editViewDataUpdate')
                this.$mask.close()

              }).catch(e => {
                console.error(e)
                this.$message.error("保存失败！");
                this.$mask.close()

              })
            } else {
              let temp = []
              this.formData.roleList.forEach(item => {
                temp.push(item)
              })
              this.formData.role = temp

              let temp1 = []
              this.formData.postList.forEach(item => {
                temp1.push(item.postId)
              })
              // this.formData.post = temp1

              let temp2 = []
              this.formData.deptList.forEach(item => {
                temp2.push(item.deptId)
              })
              // this.formData.post = temp2

              if (this.formData.password === '') {
                this.formData.password = null
              }
              this.$http({
                url: '/admin/user',
                method: `put`,
                data: this.formData
              }).then(() => {
                this.$message.success("修改成功！");
                this.reload()
                this.$mask.close()

                // this.$emit('editViewDataUpdate')
              }).catch(e => {
                console.error(e)
                this.$message.error("保存失败！");
                this.$mask.close()

              })
            }
          })
        }
      })
    },
    commit(data) {
      console.log(data, '弹框选中')
      let temp = []
      data.forEach(item => {
        temp.push({
          id: -new Date().getTime() + Math.floor(Math.random() * 1000),
          packageItemId: item.id,
          brandName: item.brandName,
          itemCode: item.itemCode,
          itemName: item.itemName,
          itemModel: item.itemModel,
          packageQty: 1,
          isNew: true
        })
      })
      if (!this.formData.basItemPackageDTOList) this.formData.basItemPackageDTOList = []
      this.formData.basItemPackageDTOList.push(...temp)
    },

    deleteData() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let temp = this.formData.basItemPackageDTOList
        this.selectedData.forEach(item => {
          temp = temp.filter(item1 => item1.id != item.id)
        })
        this.formData.basItemPackageDTOList = temp
      })
    },

    selectChangeEvent({records}) {
      console.log('选中', records)
      this.selectedData = records
    },


  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 165px !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-select__tags > span {
  display: flex !important;;
}
</style>
